module.exports = __webpack_public_path__ + "img/PlatformComposition_Data.074177ba.png";